import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { UnitLabel } from "./UnitLabel";
import { unitOf } from "./pricingUnits";
import { AwsTierRow } from "./AwsTierRow";
import { LivenessTierRow } from "./LivenessTierRow";
import { DerivedPricingCard } from "./DerivedPricingCard";

const FIELDS = [
  ["price_per_token", "tokens.pricePerToken", "number", "per_token"],
  ["operational_margin_percent", "tokens.margin_field", "number", "percent"],
  ["grace_percent", "tokens.gracePercent", "number", "percent"],
  ["face_storage_cost_per_month", "tokens.storageCost", "number", "per_face_month"],
  ["currency", "tokens.currency", "text", "tokens.unitIso"],
  ["min_custom_tokens", "tokens.minTokens", "number", "tokens.unitToken"],
  ["welcome_tokens", "tokens.welcomeTokens", "number", "tokens.unitToken"],
];

export const TokenPricingFields = ({ config, set, setPackages, setTier, setLivenessTier }) => {
  const { t } = useTranslation();
  const currency = config.currency || "USD";
  const welcomeEnabled = config.welcome_tokens_enabled !== false;

  return (
    <>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {FIELDS.map(([key, label, type, unit]) => (
          <div key={key}>
            <UnitLabel text={t(label)} unit={unitOf(unit, currency, t)} />
            <NeuInput data-testid={`token-${key}`} type={type} step="any"
                      value={config[key]} disabled={key === "welcome_tokens" && !welcomeEnabled}
                      onChange={(e) => set(key, e.target.value, type === "number")} />
          </div>
        ))}
      </div>

      <label className="mt-4 flex items-center gap-3 rounded-2xl bg-background p-3 shadow-neu-in cursor-pointer"
             data-testid="welcome-tokens-toggle-row">
        <input type="checkbox" data-testid="welcome-tokens-enabled"
               checked={welcomeEnabled}
               onChange={(e) => set("welcome_tokens_enabled", e.target.checked, false)}
               className="h-5 w-5 accent-primary" />
        <div className="flex-1">
          <p className="text-sm font-black">{t("tokens.welcomeEnabled")}</p>
          <p className="text-[11px] text-muted-foreground">{t("tokens.welcomeEnabledHint")}</p>
        </div>
      </label>

      <DerivedPricingCard config={config} />

      <div className="mt-5">
        <UnitLabel text={t("tokens.packages")} unit={t("tokens.unitToken")} />
        <NeuInput data-testid="token-packages" value={config.packages.join(", ")}
                  onChange={(e) => setPackages(e.target.value)} />
        <p className="mt-1 text-[11px] text-muted-foreground">{t("tokens.packagesHint")}</p>
      </div>

      <ul className="mt-5 space-y-3">
        <li className="label-xs">{t("tokens.compareTiers")}</li>
        {config.aws_tiers.map((tier, index) => (
          <AwsTierRow key={index} tier={tier} index={index} currency={currency} onChange={setTier} />
        ))}
      </ul>

      <ul className="mt-5 space-y-3">
        <li className="label-xs">{t("tokens.livenessTiers")}</li>
        {(config.liveness_tiers || []).map((tier, index) => (
          <LivenessTierRow key={index} tier={tier} index={index} currency={currency} onChange={setLivenessTier} />
        ))}
      </ul>
    </>
  );
};
